<app-grouped-page-container [groups]="groups" [title]="title"></app-grouped-page-container>
